import { Component } from '@angular/core';
import { NavController, ModalController, AlertController } from 'ionic-angular';
import * as moment from 'moment';

import { VariablesProvider } from '../../providers/variables/variables';
import { FuncionesProvider } from '../../providers/funciones/funciones';
import { PicajesPage } from '../../pages/picajes/picajes';
import { TrabajadoresPage } from '../../pages/trabajadores/trabajadores';
import { CalendarioPage } from '../../pages/calendario/calendario';
import { AlbaranesPage } from '../../pages/albaranes/albaranes';
import { LoginPage } from '../../pages/login/login';
import { InformesPage } from '../../pages/informes/informes';
import { CalendarModal, CalendarModalOptions, DayConfig, CalendarResult } from "ion2-calendar";
import { CalendarComponentOptions } from 'ion2-calendar'
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { HomePage } from '../../pages/home/home';

@Component({
  selector: 'page-albtrabajadores',
  templateUrl: 'albtrabajadores.html'
})

export class AlbtrabajadoresPage{
  FROM = "";
  diasdefiesta;
  myForm: FormGroup;
  myForm1: FormGroup;
  misapp: Array<{title: string, descripcion: string, imagen: string , component: any}>;
  formulario = {codigo1: "",nombre1: "",horas1: "",horainicio1: "",activo1: ""}
  resultado;
  date: string;
  type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  minuto = []; //= {valor: "1",color: "1"}
  color = []; //= {valor: "1",color: "1"}
  cabecera = []; //= {valor: "1",color: "1"}
  trabajadores;
  valo="654321123456" ;
  formulario2 = {valor: ""}
   muestragif;
     FechaIni;
  FechaFin;

  optionsRange: CalendarModalOptions = {
   pickMode:"range",
    color:'dark',
    weekStart:12,
    weekdays:['LU', 'MA', 'MI', 'JU', 'VI', 'SA', 'DO'],
    monthFormat: 'MMM',
    canBackwardsSelected: true
   };
  
 
  constructor(
    public fb: FormBuilder,
    public modalCtrl: ModalController,
    public navCtrl: NavController,
    public funciones:FuncionesProvider,
    public variables:VariablesProvider
    ) {                    
            this.variables.primeravez=="si"
            this.variables.btatras = true;
            var sum = 0;
            var horas=0;
            
            this.cabecera[0] = "s";

            this.date = this.variables.DIA;
            
            var f = new Date();
           
            this.FechaIni = this.date ;
            this.FechaFin = this.date ;
          

  
      this.myForm = this.fb.group({

      codigo: ['', [Validators.required]],
      nombre: ['', [Validators.required]],
      horas: ['', [Validators.required]],
      horainicio: ['', [Validators.required]],
      activo: ['', [Validators.required]]
    
     });

 this.myForm1 = this.fb.group({

      codigo1: ['', [Validators.required]],
      nombre1: ['', [Validators.required]],
      horas1: ['', [Validators.required]],
      horainicio1: ['', [Validators.required]],
      activo1: ['', [Validators.required]]
    
     });
   
    this.muestragif = "si";

    this.obtenertrabajadores(this.valo);

  }

  ionViewDidEnter() {

     this.muestragif = "si";
     
    this.obtenertrabajadores(this.valo);
    
    }



 onChange($event) {

  


  var cadena  = $event;
   
  this.FechaIni = $event.from;
  this.FechaFin = $event.to;

   this.muestragif = "si";
  
   this.obtenertrabajadores(this.valo);
    
    //console.log($event);   
    
  }

  obtenertrabajadores(filtro){

    if (filtro=="formulario") {
      filtro = this.formulario2.valor;
    }
    if (filtro=="") {
      filtro = this.valo;
    }

   if (this.variables.CONTROLACCESO == 11){
      filtro = this.variables.CLIENTES_RAZSOCIAL;
    }
    var lug;
    var Local;

    if (this.variables.DIA) { 
      // code...
    } else {
       var f = new Date();
       this.variables.DIA =   f.getFullYear() + "-" + ("0" + (f.getMonth() + 1)).slice(-2) + "-" +("0" + (f.getDate())).slice(-2) ; 
    }

    //console.log(filtro + this.variables.DIA);
    this.funciones.obtienetrabajadoresalbaranes(filtro,this.FechaIni,this.FechaFin).then(
          data => {
            this.trabajadores = data;
             this.muestragif = "no";
          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
  }

  
salir(){
   this.navCtrl.push(HomePage);
}

   openPicajes(codigotrabajador,nombretrabajador){

    this.variables.CODIGOTRABAJADOR = codigotrabajador;
    this.variables.NOMBRETRABAJADOR = nombretrabajador;

    this.variables.DIA = this.FechaIni;

    this.variables.primeravez="si";
    
    this.navCtrl.push(AlbaranesPage);
  }

}




// WEBPACK FOOTER //
// ./src/pages/albtrabajadores/albtrabajadores.ts